<template>
  <div id="logo" class="logo" @click="$router.push('/')"><span>SPORTDEMO</span></div>
</template>

<script>
export default {
  data () {
    return {
      open: false
    }
  }
}
</script>

<style scoped>
.logo { /* background: url(./assets/BS.png);
        display: inline-block;
        width: 155px;
        background-size: 122px;
        background-repeat: no-repeat;
        margin-top: 11px;
        margin-left: 32px;
        margin-right: 15px; */
  font-size: 22pt;
  font-weight: 700;
  text-shadow: 3px 3px 5px #000;
  margin-top: -4px;
  color: darkorange;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/Logo.vue